module.exports = __webpack_public_path__ + "assets/svg/Icons/32/time-gray-bb8d33.svg";